import moment from 'moment';
import React from 'react';
import {
  EPavementConcretingStatus,
  IPavement
} from '../../../../../../../../store/ducks/fabrication-mockups/types';
import { Container } from './styles';
import { Tag } from '@gerdau/hefesto/Tag';

interface IConcretingProps {
  pavement: IPavement;
}

const Concreting: React.FC<IConcretingProps> = ({ pavement }) => {
  const getVariantStatus = (status: string) => {
    switch (status) {
      case EPavementConcretingStatus.WAITING_MATERIAL:
        return 'warning';
      case EPavementConcretingStatus.MATERIAL_AVAILABLE:
        return 'primary';
      case EPavementConcretingStatus.DONE:
        return 'success';

      default:
        return '';
    }
  };

  return (
    <>
      <Container>
        <span className="title">Data da concretagem</span>
        <span className="subtitle">
          Laje:
          {pavement.slabDate ? (
            moment(pavement.slabDate).format(' DD/MM/YYYY')
          ) : (
            <>
              <> dd/mm/aaaa</>
              <div className="pavement-content-tag">
                <Tag variant="neutral">Não iniciado</Tag>
              </div>
            </>
          )}
          {pavement.slabDate && (
            <div className="pavement-content-tag">
              <Tag
                variant={pavement.slabStatus?.replace(
                  pavement.slabStatus,
                  getVariantStatus(pavement.slabStatus)
                )}
              >
                {pavement.slabStatus}
              </Tag>
            </div>
          )}
        </span>

        <span className="subtitle">
          Viga:
          {pavement.beamDate ? (
            moment(pavement.beamDate).format(' DD/MM/YYYY')
          ) : (
            <>
              <> dd/mm/aaaa</>
              <div className="pavement-content-tag">
                <Tag variant="neutral">Não iniciado</Tag>
              </div>
            </>
          )}
          {pavement.beamDate && (
            <div className="pavement-content-tag">
              <Tag
                variant={pavement.beamStatus?.replace(
                  pavement.beamStatus,
                  getVariantStatus(pavement.beamStatus)
                )}
              >
                {pavement.beamStatus}
              </Tag>
            </div>
          )}
        </span>

        <span className="subtitle">
          Pilar:
          {pavement.pillarDate ? (
            moment(pavement.pillarDate).format(' DD/MM/YYYY')
          ) : (
            <>
              <> dd/mm/aaaa</>
              <div className="pavement-content-tag">
                <Tag variant="neutral">Não iniciado</Tag>
              </div>
            </>
          )}
          {pavement.pillarDate && (
            <div className="pavement-content-tag">
              <Tag
                variant={pavement.pillarStatus?.replace(
                  pavement.pillarStatus,
                  getVariantStatus(pavement.pillarStatus)
                )}
              >
                {pavement.pillarStatus}
              </Tag>
            </div>
          )}
        </span>
      </Container>
    </>
  );
};

export default Concreting;
